<div class="row">
  <div class="tab-wrapper planning-module-permissions col-12">
    <div class="checkbox-wrapper d-flex mt-8 mb-16">
      <app-checkbox
        id="canAccesPlanningModule"
        [isChecked]="hasAccessToModule(moduleTypes.Incidents) || isInPrimaryRole"
        [disabled]="isInPrimaryRole"
        (checked)="selectIncidentUserRole($event)"
      ></app-checkbox>
      <span>{{ T.settings.employees_departments_org.manage_employee.can_access_control_module | translate }}</span>
    </div>
    @if(hasAccessToModule(moduleTypes.Incidents) || isInPrimaryRole)
    {
 <div class="checkbox-wrapper d-flex mt-8 mb-16">
        <app-checkbox
          id="isControlAdmin"
          [isChecked]="isInRole(employeeRoleTypes.Control_Admin) || isInPrimaryRole"
          [disabled]="isInPrimaryRole || !hasAccessToObject(objectTypes.IncidentItem)"
          (checked)="selectControlAdmin($event)"
        ></app-checkbox>
        <span>{{ T.settings.my_preferences.permissions.employee_roles.control_admin | translate }}</span>
        <app-button-transparent
          class="col-5 text-left"
          [app-tooltip]="{
            title: T.settings.my_preferences.permissions.employee_roles.control_admin | translate,
            message: T.settings.my_preferences.permissions.control_admin_tooltip | translate
          }"
          size="small"
          icon="error_outline"
          [text]="T.common.learn_more | translate"
          iconFontSize="16"
        ></app-button-transparent>
      </div>
      @if(account.usePeaps) {
        <div class="checkbox-wrapper d-flex mt-8 mb-16">
          <app-checkbox
            id="isPeapsUser"
            [isChecked]="hasAccessToObject(objectTypes.PEAP) || isInPrimaryRole"
            [disabled]="isInPrimaryRole"
            (checked)="selectPeapsAccess($event)"
          ></app-checkbox>
          <span>{{ T.common.can_acess_items | translate: { items: localisePEAPs } }}</span>
        </div>
        <div class="checkbox-wrapper d-flex mb-32">
          <app-checkbox
            id="isPeapsController"
            [isChecked]="isInRole(employeeRoleTypes.PEAPS_Controller) || isInPrimaryRole"
            [disabled]="isInPrimaryRole"
            (checked)="selectPeapsController($event)"
          ></app-checkbox>
          <span>{{
            T.settings.employees_departments_org.manage_employee.localisedPEAPs_controller
              | translate: { localisedPEAPs: localisePEAPs }
          }}</span>
          <app-button-transparent
            class="col-5 text-left"
            [app-tooltip]="{
              title:
                T.settings.employees_departments_org.manage_employee.localisedPEAPs_controller
                | translate: { localisedPEAPs: localisePEAPs },
              message:
                T.settings.employees_departments_org.manage_employee.localisedPEAPs_controller_tooltip
                | translate: { localisedPEAPs: localisePEAPs }
            }"
            size="small"
            icon="error_outline"
            [text]="T.common.learn_more | translate"
            iconFontSize="16"
          ></app-button-transparent>
        </div>
      }
      @if(account.useIncidents) {
        <div class="checkbox-wrapper d-flex mt-8 mb-16">
          <app-checkbox
            id="canAccessIncidents"
            [isChecked]="hasAccessToObject(objectTypes.IncidentItem) || isInPrimaryRole"
            [disabled]="isInPrimaryRole"
            (checked)="selecUserRole($event, objectTypes.IncidentItem)"
          ></app-checkbox>
          <span>{{ T.common.can_acess_items | translate: { items: localisedIncidentsAndLogs } }}</span>
        </div>
      }
      @if(account.useJobs) {
        <div class="checkbox-wrapper d-flex mt-8 mb-16">
          <app-checkbox
            id="canAccesJobs"
            [isChecked]="hasAccessToObject(objectTypes.Job) || isInPrimaryRole"
            [disabled]="isInPrimaryRole"
            (checked)="selecUserRole($event, objectTypes.Job)"
          ></app-checkbox>
          <span localise>Can Access Jobs</span>
        </div>
      }
    }
    @if(hasAccessToObject(objectTypes.IncidentItem) || isInPrimaryRole) {
      <div class="projects-and-tasks">
      <div class="sub-section-label d-flex mt-16 mb-16">
        <span class="material-symbols-outlined">room</span>
        <span class="ms-8">{{ T.control.incidents_and_log_items | translate }}</span>
      </div>
      <app-employee-permissions-section [employee]="employeeDetailsViewModel"
      [filterType]="filterTypes.Incident" [module]="moduleTypes.Incidents"
      [isInPrimaryRole]="isInPrimaryRole" [isDepartmentSelected]="isDepartmentSelected"
      (permissionsChanged)="updateEmployeePermissions($event)">

      </app-employee-permissions-section>
      <div class="sub-section-label d-flex mt-32 mb-16">
        <span class="material-symbols-outlined">lock</span>
        <span class="ms-8">{{
          T.settings.employees_departments_org.manage_employee.confidential_incidents | translate
        }}</span>
        <app-button-transparent
          class="col-5 text-left"
          [app-tooltip]="{
            title: T.settings.employees_departments_org.manage_employee.confidential_incidents | translate,
            message: T.settings.my_preferences.permissions.can_see_confidential_incidents_tooltip | translate
          }"
          size="small"
          icon="error_outline"
          [text]="T.common.learn_more | translate"
          iconFontSize="16"
        ></app-button-transparent>
      </div>
      <div class="projects-and-tasks__role-permissions">
        <app-filter-dropdown-new
          id="privacyStatus"
          [filterByModuleObjectType]="false"
          [filterType]="filterTypes.Privacy_Status"
          [disableMargin]="true"
          [appliedFilters]="confidentialTypeFilters"
          [singleSelect]="false"
          [typeahead]="true"
          [usePredefinedFilters]="true"
          [predefinedFilters]="privacyStatusFilters"
          (onFilterUpdate)="updateConfidentialTypes($event)"
        >
        </app-filter-dropdown-new>
      </div>
    </div>
    }
    @if(hasAccessToObject(objectTypes.Job)|| isInPrimaryRole) {
    <div class="projects-and-tasks">
      <div class="sub-section-label d-flex mt-16 mb-16">
        <span class="material-symbols-outlined">room</span>
        <span class="ms-8" localise>Jobs</span>
      </div>
      <app-employee-permissions-section [employee]="employeeDetailsViewModel"
      [filterType]="filterTypes.Job" [module]="moduleTypes.Incidents"
      [isInPrimaryRole]="isInPrimaryRole" [isDepartmentSelected]="isDepartmentSelected"
      (permissionsChanged)="updateEmployeePermissions($event)">

      </app-employee-permissions-section>
      <div class="sub-section-label d-flex mt-32 mb-16">
        <span class="material-symbols-outlined">lock</span>
        <span class="ms-8">{{ confidentialJobsTitle }}</span>
        <app-button-transparent
          class="col-5 text-left"
          [app-tooltip]="{
            title: confidentialJobsTitle,
            message:
              T.settings.employees_departments_org.manage_employee.confidentialJobs_access_tooltip
              | translate: { localisedJobs: localisedJobs }
          }"
          size="small"
          icon="error_outline"
          [text]="T.common.learn_more | translate"
          iconFontSize="16"
        ></app-button-transparent>
      </div>
      <div class="projects-and-tasks__role-permissions">
        <app-filter-dropdown-new
          id="privacyStatus"
          [filterByModuleObjectType]="false"
          [filterType]="filterTypes.Privacy_Status"
          [disableMargin]="true"
          [appliedFilters]="confidentialJobTypeFilters"
          [singleSelect]="false"
          [typeahead]="true"
          [usePredefinedFilters]="true"
          [predefinedFilters]="privacyStatusFilters"
          (onFilterUpdate)="updateJobConfidentialTypes($event)"
        >
        </app-filter-dropdown-new>
      </div>
    </div>
    }
  </div>
</div>
